/* eslint-disable semi */
/* eslint-disable react/static-property-placement */
/* eslint-disable max-len */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable indent */
import * as H from 'history'
import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { ApplicationController } from '../../controllers/ApplicationController'
import { ApplicationModel } from '../../models/ApplicationModel'
import { ApplicationDocumentModel } from '../../models/ApplicationDocumentModel'
import { Consultant } from '../../models/Consultant'
import { ISupportSpinner } from '../../shared/Ajax'
import { Backdrop } from '../../shared/Backdrop'
import { Option } from '../../shared/fields/Options'
import { TimeoutPopup } from '../../shared/TimeoutPopup'
import { EligibleApplicantPage, PreviewObj } from './EligibleApplicantPage'
import { EligibleTiersPage } from './EligibleTiers'
import { EligibleProductsPage } from './EligibleProductsPage/index'
import { EligibleExpensesPage } from './EligibleExpensesPage/index'
import { ApplicationFinalisationPage } from './ApplicationFinalisationPage/index'
import { BusinessPartnerPage } from './EligibleApplicantPage/otherTables/businessPartners/BusinessPartnerPage'
import { RelatedCompanyPage } from './EligibleApplicantPage/otherTables/RelatedCompany/RelatedCompanyPage'
import { CompanyHistoryPage } from './EligibleApplicantPage/otherTables/companyHistory/CompanyHistoryPage'
import { ApplicationPayload } from '../../models/ApplicationPayload'
import { documentTypeInfo } from './documents/DocumentTypeInfo'
import { DocumentUploadPage } from './documents/DocumentUploadPage'
import { PreviewPage } from './PreviewPage'
import { SubmissionPage } from './SubmissionPage'
import { getInvalidFileBlobIds } from '../../shared/Utility'
import { PlannedExpenditureCap } from '../../models/PlannedExpenditureCap'
import { FinancialYearModel } from '../../models/FinancialYearModel'
import { GUID } from '../../models/Guid'

export interface ApplicationForm2Props {
    history: H.History
    location: H.Location
    applicationId: string
}

export interface ApplicationForm2State {
    loading: boolean
    readOnly: boolean
    model: ApplicationModel
    autoClaimNumber: string
    blobID: GUID
    addressCountries: Option<string>[]
    markets: Option<string>[]
    marketsKeyOnly: Option<string>[];
    marketRegions: string[]
    consultants: Consultant[]
    autoLogout: boolean
    showPdfContent: boolean
    uploadedDocuments: ApplicationDocumentModel[]
    plannedExpendituresCapAmount: PlannedExpenditureCap
    currentApplicationPeriod: FinancialYearModel
    previewObj: PreviewObj // workaround to be used whenever it's useful.
    financialYears: Option<string>[]
    eligibleExpenseCategories: Option<string>[]
}

interface Tab {
    link: string,
    text: string
}

const tabs: Tab[] = [
    {
        link: 'applicant',
        text: 'Eligible applicant',
    },
    {
        link: 'eligibletiers',
        text: 'Eligible tiers',
    },
    {
        link: 'expenses',
        text: 'Plan to market & eligible expenses',
    },
    {
        link: 'products',
        text: 'Eligible products',
    },
    {
        link: 'finalise',
        text: 'Application finalisation',
    },
]

export const GRANT_GUIDELINES_URL = 'https://www.austrade.gov.au/content/dam/austrade-assets/global/wip/austrade/documents/emdg-grant-guidelines-round-4.docx';
export const ABR_WEBSITE_URL = 'https://abr.business.gov.au/';
export const ASIC_WEBSITE_URL = 'https://asic.gov.au/';

export class ApplicationForm2 extends React.Component<ApplicationForm2Props, ApplicationForm2State> implements ISupportSpinner {
    ajax: ApplicationController

    previewForm: HTMLFormElement

    previewInput: HTMLInputElement

    previewContent: HTMLDivElement

    constructor(props: ApplicationForm2Props) {
        super(props)

        this.ajax = new ApplicationController()

        this.state = {
            loading: false,
            readOnly: false,
            model: null,
            autoClaimNumber: null,
            blobID: null,
            addressCountries: [],
            markets: [],
            marketsKeyOnly: [],
            marketRegions: [],
            consultants: [],
            autoLogout: false,
            showPdfContent: false,
            uploadedDocuments: [],
            plannedExpendituresCapAmount: null,
            currentApplicationPeriod: null,
            previewObj: {
                selectedTierDisplayName: '',
                priorityTradeAreaDisplayName: '',
            },
            financialYears: [],
            eligibleExpenseCategories: [],
        }
    }

    componentDidMount() {
        window.onbeforeunload = () => {
            if (!this.state.autoLogout) return 'Changes you made may not be saved.'
            return undefined;
        }
        this.load()
    }

    componentDidUpdate(prevProps: ApplicationForm2Props) {
        if (this.props.applicationId !== prevProps.applicationId || (this.state.model && this.state.model.applicationID !== this.props.applicationId)) {
            this.load()
        } else if (this.props.location.pathname !== prevProps.location.pathname) {
            let { lastValidPage } = this.state.model
            if (this.getTabIndex(this.props.location.pathname) > this.getTabIndex(this.state.model.lastValidPage)) {
                lastValidPage = this.props.location.pathname
            }

            this.setState({
                        model: {
                            ...this.state.model,
                             currentPage: this.props.location.pathname,
                             lastValidPage,
                        },
            });
        }
    }

    componentWillUnmount() {
        window.onbeforeunload = null
        this.ajax.cancel()
    }

    onAutoLogout = () => {
        this.setState({ autoLogout: true })
    }

    toggleSpinner(on: boolean, callback: { (): any }): void {
        this.setState({ loading: on }, callback)
    }

    // eslint-disable-next-line class-methods-use-this
    getTabIndex = (url: string) => {
        if (url) {
            if (url.indexOf('/submission') >= 0) return 3

            for (let i = 0; i < tabs.length; i++) {
                if (url.toLowerCase().indexOf(tabs[i].link.toLowerCase()) >= 0) {
                    return i
                }
            }
        }
        return 0
    }

    getTab = (url: string) => tabs[this.getTabIndex(url)]

    async load(): Promise<void> {
        await this.ajax.getItem(this, this.props.applicationId, (payload: ApplicationPayload) => {
            this.setState(payload, () => {
                if (payload !== null) {
                    if (!this.state.readOnly) {
                        this.setState({
                                model: { ...this.state.model, applicationDocuments: payload.uploadedDocuments },
                                currentApplicationPeriod: payload.currentApplicationPeriod,
                                financialYears: payload.financialYears,
                                eligibleExpenseCategories: payload.eligibleExpenseCategories,
                            }, () => {
                            const tab = this.getTab(payload.model.currentPage)
                            this.props.history.replace(`/reform/${this.props.applicationId}/${tab.link}`)
                        })
                    } else {
                        this.setState({ model: { ...this.state.model, applicationDocuments: payload.uploadedDocuments } }, () => {
                            this.props.history.replace(`/reform/${this.props.applicationId}/preview`)
                        })
                    }
                }
            })
        })
    }

    navigate = (tabIndex: number) => {
        const lastValidTabIndex = this.getTabIndex(this.state.model.lastValidPage)
        if (tabIndex > lastValidTabIndex) {
            alert("Please use 'Save & Next' button to navigate to the tab")
            return
        }
        this.props.history.push(`/reform/${this.props.applicationId}/${tabs[tabIndex].link}`)
    }

    saveAndExit = (e: React.MouseEvent) => {
        e.preventDefault()
        const invalidDocuments = getInvalidFileBlobIds(this.state.model)

        const eligExpenseArray = [...this.state.model.eligibleExpenses]
        const fullEligExpenseArray = eligExpenseArray.filter((row) => {
            if (row.crmEligibleExpenditureCategoryID !== undefined && row.crmEligibleExpenditureCategoryID != null && row.crmEligibleExpenditureCategoryID !== '00000000-0000-0000-0000-000000000000'
                && row.fyExpenditureAmount1 > 0 && row.fyExpenditureAmount2 > 0) { return row }
        })

        // don't save partially completed rows in table
        const finArray = [...this.state.model.exportMarketFinancials]
        const fullRowsOnly = finArray.filter((row) => {
            if (row.crmExportMarketID && row.earnings
                && row.crmExportMarketID.length >= 32 && !Number.isNaN(row.earnings)) {
                return row
            }
        })
        const newModel = JSON.parse(JSON.stringify(this.state.model))
        newModel.exportMarketFinancials = fullRowsOnly
        newModel.eligibleExpenses = fullEligExpenseArray
        //  const updatedModel = { ...JSON.parse(JSON.stringify(this.state.model)), invalidDocuments }
        const updatedModel = { ...newModel, invalidDocuments }
        this.ajax.updateApplication(this, updatedModel, () => {
            this.props.history.push('/')
        })
    }

    save = (e: React.MouseEvent) => {
        e.preventDefault()
        const invalidDocuments = getInvalidFileBlobIds(this.state.model)

        const eligExpenseArray = [...this.state.model.eligibleExpenses]
        const fullEligExpenseArray = eligExpenseArray.filter((row) => {
            if (row.crmEligibleExpenditureCategoryID !== undefined && row.crmEligibleExpenditureCategoryID != null && row.crmEligibleExpenditureCategoryID !== '00000000-0000-0000-0000-000000000000'
                && row.fyExpenditureAmount1 > 0 && row.fyExpenditureAmount2 > 0) { return row }
        })

        // don't save partially completed rows in table
        const finArray = [...this.state.model.exportMarketFinancials]
        const fullRowsOnly = finArray.filter((row) => {
            if (row.crmExportMarketID && row.earnings
                && row.crmExportMarketID.length >= 32 && !isNaN(row.earnings)) {
                return row
            }
        })

        const newModel = JSON.parse(JSON.stringify(this.state.model))
        newModel.exportMarketFinancials = fullRowsOnly
        newModel.eligibleExpenses = fullEligExpenseArray
        //  const updatedModel = { ...JSON.parse(JSON.stringify(this.state.model)), invalidDocuments }
        const updatedModel = { ...newModel, invalidDocuments }
        this.ajax.updateApplication(
            this,
            updatedModel,
            (d) => {
                this.setState({ model: { ...this.state.model, ...d } })
            },
)
    }

    preview = (e: React.MouseEvent) => {
        e.preventDefault()
        this.setState({ showPdfContent: true }, () => {
            this.previewInput.value = this.previewContent.innerHTML
            this.previewForm.submit()
            this.setState({ showPdfContent: false })
        })
    }

    onChange = (changes: Partial<ApplicationModel>, callback?: () => any) => {
        // console.log('changes:', changes);
        this.setState(
            (prevState) => ({
                model: { ...prevState.model, ...changes, lastValidPage: this.props.location.pathname },
            }),
            callback,
        )
    }

    onSubmit = (autoClaimNumber: string, blobID: GUID, callback?: { (): any }) => {
        this.setState({ autoClaimNumber, blobID }, callback)
    }

    setPreviewObj = (updated: Partial<PreviewObj>) => {
        this.setState((prevState) => ({
            previewObj: {
                ...prevState.previewObj,
                ...updated,
            },
        }));
    }

    render() {
        if (!this.state.model || this.state.model.applicationID != this.props.applicationId) {
            return <div className="container-fluid mt-2 text-center"><h5>Please wait. Loading...</h5></div>
        }

        let routes = (
          <Switch>
            <Route path="/reform/:id/applicant" exact render={(p) => <EligibleApplicantPage model={this.state.model} onChange={this.onChange} history={p.history} consultants={this.state.consultants} addressCountries={this.state.addressCountries} currentApplicationPeriod={this.state.currentApplicationPeriod} markets={this.state.markets} marketsKeyOnly={this.state.marketsKeyOnly} marketRegions={this.state.marketRegions} previewObj={this.state.previewObj} setPreviewObj={this.setPreviewObj} />} />
            <Route path="/reform/:id/applicant/businesspartners" render={(p) => <BusinessPartnerPage model={this.state.model} onChange={this.onChange} history={p.history} />} />
            <Route path="/reform/:id/applicant/relatedcompanies" render={(p) => <RelatedCompanyPage model={this.state.model} onChange={this.onChange} history={p.history} addressCountries={this.state.addressCountries} />} />
            <Route path="/reform/:id/applicant/companyhistories" render={(p) => <CompanyHistoryPage model={this.state.model} onChange={this.onChange} history={p.history} />} />
            <Route path="/reform/:id/products" render={(p) => <EligibleProductsPage model={this.state.model} history={p.history} onChange={this.onChange} />} />
            <Route path="/reform/:id/expenses" render={(p) => <EligibleExpensesPage model={this.state.model} onChange={this.onChange} history={p.history} markets={this.state.markets} marketRegions={this.state.marketRegions} financialYears={this.state.financialYears} eligibleExpenseCategories={this.state.eligibleExpenseCategories} />} />
            <Route path="/reform/:id/eligibletiers" render={(p) => <EligibleTiersPage model={this.state.model} onChange={this.onChange} history={p.history} markets={this.state.markets} marketRegions={this.state.marketRegions} />} />
            <Route path="/reform/:id/finalise" render={(p) => <ApplicationFinalisationPage model={this.state.model} onChange={this.onChange} history={p.history} onSubmit={this.onSubmit} addressCountries={this.state.addressCountries} consultants={this.state.consultants} markets={this.state.markets} marketsKeyOnly={this.state.marketsKeyOnly} marketRegions={this.state.marketRegions} previewObj={this.state.previewObj} setPreviewObj={this.setPreviewObj} currentApplicationPeriod={this.state.currentApplicationPeriod} financialYears={this.state.financialYears} eligibleExpenseCategories={this.state.eligibleExpenseCategories} />} />
            <Route path="/reform/:id/submission" render={(p) => <SubmissionPage model={this.state.model} history={p.history} autoClaimNumber={this.state.autoClaimNumber} blobID={this.state.blobID} onPrint={this.preview} />} />
            <Route path="/reform/:id/documents/:code/:item?" render={(p) => <DocumentUploadPage model={this.state.model} code={p.match.params.code} item={p.match.params.item || ''} onChange={this.onChange} history={p.history} />} />
          </Switch>
        )
        if (this.state.readOnly) {
            routes = (
              <Switch>
                <Route
                  path="/reform/:id/preview"
                  exact
                  render={
                            (p) => (
                              <PreviewPage
                                model={this.state.model}
                                onChange={this.onChange}
                                onSubmit={this.onSubmit}
                                history={p.history}
                                markets={this.state.markets}
                                marketsKeyOnly={this.state.marketsKeyOnly}
                                marketRegions={this.state.marketRegions}
                                consultants={this.state.consultants}
                                addressCountries={this.state.addressCountries}
                                onPrint={this.preview}
                                currentApplicationPeriod={this.state.currentApplicationPeriod}
                                financialYears={this.state.financialYears}
                                eligibleExpenseCategories={this.state.eligibleExpenseCategories}
                                previewObj={this.state.previewObj}
                              />
                            )
                        }
                />
              </Switch>
            )
        }

        const pdfContent = this.state.showPdfContent
            ? (
              <>
                <div ref={(r) => this.previewContent = r}>
                  <PreviewPage
                    model={this.state.model}
                    onChange={this.onChange}
                    onSubmit={this.onSubmit}
                    history={this.props.history}
                    markets={this.state.markets}
                    marketsKeyOnly={this.state.marketsKeyOnly}
                    marketRegions={this.state.marketRegions}
                    consultants={this.state.consultants}
                    addressCountries={this.state.addressCountries}
                    currentApplicationPeriod={this.state.currentApplicationPeriod}
                    financialYears={this.state.financialYears}
                    eligibleExpenseCategories={this.state.eligibleExpenseCategories}
                    previewObj={this.state.previewObj}
                  />
                </div>
                <form ref={(r) => this.previewForm = r} action="/api/pdf" target="_blank" method="POST" style={{ display: 'none' }}>
                  <input type="hidden" name="content" ref={(r) => this.previewInput = r} />
                  <input type="hidden" name="orgName" value={`${this.state.model.registeredBusinessName} Application ${this.state.model.financialYearName}`} />
                </form>
              </>
            )
            : <></>

        const currentTabIndex = this.getTabIndex(this.props.location.pathname)
        const lastValidTabIndex = this.getTabIndex(this.state.model.lastValidPage)

        const documents: JSX.Element[] = []

        const preparePart = this.props.location.pathname.indexOf('/finalise')
        const previewPage = this.props.location.pathname.indexOf('/preview') >= 0
        const submissionPage = this.props.location.pathname.indexOf('/submission') >= 0

        if (previewPage || submissionPage) {
            return (
              <div className="container-fluid mt-2">
                <div className="row">
                  <div className="col-lg-9">
                    {routes}
                  </div>
                </div>
                {pdfContent}
                <TimeoutPopup onLogout={this.onAutoLogout} />
              </div>
            )
        }

        if (preparePart < 0) {
            for (const docType of documentTypeInfo) {
                const items = docType.reducer(this.state.model)
                for (const id of items) {
                    if (docType.quickList(this.state.model, id)) {
                        let className = 'custom-icon-nav-link todo'
                        //  console.log('this.state.model.applicationDocuments', this.state.model.applicationDocuments)
                        if (this.state.model.applicationDocuments && this.state.model.applicationDocuments.filter((r) => r.code == docType.code).length > 0) {
                            className = 'custom-icon-nav-link done'
                        }
                        documents.push(<li key={`${docType.code}-${id}`}>
                          <a className={className} href="#" onClick={(e) => { e.preventDefault(); this.props.history.push(`/reform/${this.state.model.applicationID}/documents/${docType.code}/${id}`) }}>
                            {docType.title(this.state.model, id)}
                          </a>
                                       </li>)
                    }
                }
            }
        } else {
            documents.push(<li key="more">
              <a href="#supportingDocumentSection">
                See Supporting Documentation...
              </a>
                           </li>)
        }
        return (
          <div className="container-fluid mt-2 ">
            <div className="row">
              <div className="col-lg-9">
                {tabs.filter((d) => this.props.location.pathname.toLowerCase().indexOf(d.link.toLowerCase()) >= 0).map((d, i) => (
                  <div key={i} className="mb-2 aus-tab-header">
                    {d.text}
                  </div>
                 ))}
                <div className="mb-3 aus-tab-container">
                  {tabs.map((d, i) => (
                    <div
                      key={i}
                      className={'aus-tab'
                        + `${i == currentTabIndex ? ' aus-tab-active' : ''}`
                        + `${i > lastValidTabIndex ? ' aus-tab-disabled' : ''}`}
                    >
                      <a id={`tab${d.text}`} className="aus-tab-title" href="#" onClick={(e) => { this.navigate(i); e.preventDefault() }}>{d.text}</a>
                      <a id={`tab${i + 1}`} className="aus-tab-number" href="#" onClick={(e) => { this.navigate(i); e.preventDefault() }}>{i + 1}</a>
                    </div>
                   ))}
                </div>
                {routes}
              </div>
              <div className="col-lg-3">
                <div className="aus-formnav">
                  <div>
                    <ul className="aus-org-name" style={{ marginBottom: '0rem' }}>
                      <li>
                        <strong>{this.state.model.registeredBusinessName}</strong>
                      </li>
                    </ul>
                    <ul className="aus-formnav-actions">
                      <li onClick={this.saveAndExit}>
                        <img src="/images/saveandexit.png" className="mr-2" />
                        <a href="#" className="custom-icon-nav-link">
                          <span className="media-body">Save & Exit</span>
                        </a>
                      </li>
                      <li onClick={this.save}>
                        <img src="/images/save.png" className="mr-2" />
                        <a href="#" className="custom-icon-nav-link">
                          <span className="media-body">Save</span>
                        </a>
                      </li>
                      <li onClick={this.preview}>
                        <img src="/images/preview.png" className="mr-2" />
                        <a href="#" className="custom-icon-nav-link">
                          <span className="media-body">Preview & Print</span>
                        </a>
                      </li>
                    </ul>
                    {documents.length > 0 ? (
                      <>
                        <h5>Required documents</h5>
                        <div style={{ color: 'gray', fontStyle: 'italic', fontSize: '.9rem' }}>Click on the links below to upload required documents</div>
                        <ul className="aus-formnav-todo">
                          {documents}
                        </ul>
                      </>
                      ) : <></>}
                  </div>
                </div>
              </div>
            </div>
            {pdfContent}
            <Backdrop on={this.state.loading} />
            <TimeoutPopup onLogout={this.onAutoLogout} />
          </div>
        )
    }
}
